import React from 'react'
import ilovalar from '../fayl/ILOVALAR.pdf'
import { Button } from 'antd'

const Ilovalar = () => {
  return (
    <div>
        <Button className='button'>
            <a href={ilovalar}>Ilovalar</a>
        </Button>
    </div>
  )
}

export default Ilovalar